export default __webpack_public_path__ + "static/media/Login-background.5259cf32.png";